import {createProductCancelPolicyPending,modifyProductCancelPolicyFail,modifyProductCancelPolicySuccess,modifyProductCancelPolicyPending,getSProductCancelPolicyFail,getSProductCancelPolicyPending,getSProductCancelPolicySuccess, createProductCancelPolicySuccess,createProductCancelPolicyFail,getSCancelPolicyPending} from "./cancelpolicySlice";
import { productcancelpolicyCreation,fetchSingleCancelPolicy,productcancelpolicyModify } from "../../../api/userApi";



export const newProductCancelPolicyCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createProductCancelPolicyPending());
        const result = await productcancelpolicyCreation(frmDt);
        result.status === "success"
            ? dispatch(createProductCancelPolicySuccess(result.message))
            : dispatch(createProductCancelPolicyFail(result.message));

    } catch (error) {
   
        const err = JSON.parse(JSON.stringify(error.response.data.errors));

       
       const row = err.map((er, i) => {
 

       
            if (i === er.length - 1) {
              return er.param+' '+er.msg+'. ';
            }
            return er.param+' '+er.msg+' ';
          });
       
          dispatch(createProductCancelPolicyFail(row));
     
       
       
       
    }

}

export const getSingleCancelPolicy = (id) => async (dispatch) => {
    
 
    try {
     //call the api
    dispatch(getSProductCancelPolicyPending());
    const result = await fetchSingleCancelPolicy(id);

 console.log("royalab",result);

 
 //console.log('check user profile out if');
    if(result.productcanclepolicies[0] && result.productcanclepolicies[0].id){
    //console.log('check user profile');
        return dispatch(getSProductCancelPolicySuccess(result.productcanclepolicies[0]));
    }
    dispatch(getSProductCancelPolicyFail("product cancel policy is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
   // console.log(err.msg);
    dispatch(getSProductCancelPolicyFail(err.msg));
 
 }
    
 
 }


export const cancelpolicyModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyProductCancelPolicyPending());
        const result = await productcancelpolicyModify(frmDt);
        result.status === "success"
            ? dispatch(modifyProductCancelPolicySuccess(result.message))
            : dispatch(modifyProductCancelPolicyFail(result.message));

          //  console.log("userRoleModify "+result);
            // console.log("try block");
            //console.log(result.status);
            //console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyProductCancelPolicyFail(err.msg));
    }

}


